// Registra o service worker escrito à mão (public/service-worker.js).
// Padrão do próprio CRA (checa suporte + registra depois do load), sem
// nenhuma lib de PWA — só o necessário pra funcionar offline.
export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ''}/service-worker.js`)
      .catch((err) => console.error('Falha ao registrar o service worker:', err));
  });
}
